let dummyData = [
    {
        number: 1,
        studentName: "Robert Fox",
        classValue: "8th",
        score: 59,
        result: "Passed",
        grade: "Average",
    },
    {
        number: 2,
        studentName: "Ralph Edwards",
        classValue: "10th",
        score: 20,
        result: "Failed",
        grade: "Poor",
    },
    {
        number: 3,
        studentName: "Esther Horward",
        classValue: "11th",
        score: 90,
        result: "Passed",
        grade: "Excellent",
    },
    {
        number: 4,
        studentName: "Eleonar Pena",
        classValue: "8th",
        score: 59,
        result: "Passed",
        grade: "Average",
    },
    {
        number: 5,
        studentName: "Arlene MaCoy",
        classValue: "10th",
        score: 90,
        result: "Passed",
        grade: "Excellent",
    },
    {
        number: 6,
        studentName: "Marvin Mckinney",
        classValue: "11th",
        score: 20,
        result: "Failed",
        grade: "Poor",
    },
    {
        number: 7,
        studentName: "Wade Warren",
        classValue: "11th",
        score: 60,
        result: "Passed",
        grade: "Average",
    }
]
export default dummyData;